import React, { useState } from 'react';
import { Typography, IconButton } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';

interface Props {
	onFileUpload: (file: File) => void;
	disabled?: boolean;
	id: string;
	accept: string; // TODO: make optional
}

const FileDropZone = ({ onFileUpload, disabled, id, accept }: Props) => {
	const [isDragging, setIsDragging] = useState(false);

	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setIsDragging(true);
	};

	const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setIsDragging(false);
	};

	const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setIsDragging(false);
		if (disabled) return;
		const file = event.dataTransfer.files[0];
		if (file && file.type.startsWith(accept.split('/*')[0])) {
			onFileUpload(file);
		}
	};

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (file) {
			onFileUpload(file);
		}
	};

	return (
		<div
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			onDrop={handleDrop}
			style={{
				border: `2px dashed ${isDragging ? '#1976d2' : '#ccc'}`,
				borderRadius: '4px',
				padding: '20px',
				textAlign: 'center',
				cursor: 'pointer',
				backgroundColor: isDragging ? 'rgba(25, 118, 210, 0.1)' : 'transparent',
			}}
		>
			<Typography variant="body2" color={isDragging ? 'primary' : 'textSecondary'}>
				{disabled ? 'Remove existing file first' : isDragging ? 'Drop file here' : 'Drag & drop file here or click to select'}
			</Typography>
			<input
				type="file"
				accept={accept}
				onChange={handleFileChange}
				style={{ display: 'none' }}
				id={id}
				disabled={disabled}
			/>
			<label htmlFor={id}>
				<IconButton component="span" disabled={disabled}>
					<UploadIcon />
				</IconButton>
			</label>
		</div>
	);
};

export default FileDropZone;